import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListRequestLeaveConfigStart,
  getListRequestLeaveConfigSuccess,
  getListRequestLeaveConfigFailed,
} from "../redux/getListRequestLeaveConfig";
import moment from "moment";
import { getListRequestLeaveConfigApi } from "core/http/service/timeKeeping";
import { formReqUpdateDetail } from "../redux/formReqLeave";
import { selectFormReqLeave } from "../redux/selector";

function* getListRequestLeaveConfigWork(action) {
  const { screenCode, ...payload } = action.payload;
  const { data } = yield select(selectFormReqLeave);
  try {
    const res = yield call(getListRequestLeaveConfigApi, screenCode, {
      ...payload,
    });
    const formattedData = res
      ?.map((item, index) => ({
        ...item,
        index: index + 1,
        fromDate: moment(item?.fromDate),
        toDate: moment(item?.toDate),
      }))
      .concat([...data.details]?.filter((item) => item?.isNew));
    yield put({
      type: getListRequestLeaveConfigSuccess.type,
      payload: formattedData,
    });
    yield put({
      type: formReqUpdateDetail.type,
      payload: formattedData,
    });
  } catch (error: any) {
    yield put({
      type: getListRequestLeaveConfigFailed.type,
    });
  }
}

function* watchGetListRequestLeaveConfig() {
  yield takeLatest(
    getListRequestLeaveConfigStart.type,
    getListRequestLeaveConfigWork
  );
}

export default function* getListRequestLeaveConfigSaga() {
  yield all([watchGetListRequestLeaveConfig()]);
}
